import React from 'react';
import PropTypes from 'prop-types';
import { HiPlus } from 'react-icons/hi';
import List from 'partial/components/List';
import Button from 'partial/components/Button';
import Pagination from 'partial/components/Pagination';
import { openChannelModal } from '../modals/ChannelModal';
import ChannelListFilter from './ChannelListFilter';
import { useChannelList, useSelectChannel } from '../hooks';

function ChannelList({ selected, onSelect }) {
  const [filter, setFilter] = React.useState({
    q: '',
    page: 1,
    sort: 'profile.first_name:asc',
  });
  const [isLoading, list, pager] = useChannelList(filter);
  const handleOpenAdd = () => {
    openChannelModal('Add Channel', undefined, onSelect);
  };
  // const renderBadge = React.useCallback(
  //   (row) => (
  //     <>
  //       {row.status === 'ACTIVE' && (
  //         <span className="badge badge-success">Published</span>
  //       )}
  //       {row.status === 'INACTIVE' && (
  //         <span className="badge badge-gray">Draft</span>
  //       )}
  //     </>
  //   ),
  //   []
  // );
  React.useEffect(() => {
    if (window.innerWidth <= 1024) return;
    if (!selected && list[0]) onSelect(list[0]);
  }, [selected, list, onSelect]);
  useSelectChannel(selected?.id);
  return (
    <>
      <div className="px-6 pt-6 pb-4">
        <div className="float-right">
          <Button icon={HiPlus} onClick={handleOpenAdd}>
            Add
          </Button>
        </div>
        <h2 className="text-lg font-medium text-gray-900">Channels</h2>
        <p className="mt-1 text-sm text-gray-600">
          Total of {pager?.total || 0} channel(s)
        </p>
        <ChannelListFilter onSubmit={setFilter} value={filter} />
      </div>
      <div className="relative flex-grow">
        <div className="absolute h-full w-full top-0 left-0 overflow-auto">
          <List
            label="channel"
            data={list}
            selected={selected}
            onSelect={onSelect}
            isLoading={isLoading}
            subTitleKey="email"
            // renderBadge={renderBadge}
          />
        </div>
      </div>
      <Pagination onChange={setFilter} value={pager} />
    </>
  );
}

ChannelList.defaultProps = {
  selected: null,
};

ChannelList.propTypes = {
  selected: PropTypes.instanceOf(Object),
  onSelect: PropTypes.func.isRequired,
};

export default ChannelList;
